// extracted by mini-css-extract-plugin
module.exports = {"tab_bgremover":"patients_tab_bgremover__gMx1L"};